import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Galerie</h2>
          <p>
            Découvrez en images et en vidéos les histoires inspirantes des femmes
            qui ont marqué le projet Destins de Femmes.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div key={i} className="col-sm-6 col-md-4 col-lg-4 mb-4">
                    <div className="embed-responsive embed-responsive-16by9">
                      <iframe
                        className="embed-responsive-item"
                        src={d.youtubeUrl}
                        title={`video-${i}`} // ✅ attribut title unique
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ width: "100%", height: "200px", border: "none" }}
                      ></iframe>
                    </div>
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
